import { Move } from 'lucide-react';
import { DragEvent, FC, ReactNode } from 'react';

import { DraggedCardContainer, DragHandle, MoveIcon } from './DraggedCardWrapper.styled';

interface DraggedCardWrapperProps {
    isHovered?: boolean;
    onDragOver?: (event: DragEvent<HTMLDivElement>) => void;
    onDragEnter?: (event: DragEvent<HTMLDivElement>) => void;
    onDrop?: (event: DragEvent<HTMLDivElement>) => void;
    onDragStart?: (e: React.DragEvent<HTMLDivElement>) => void;
    onDragEnd?: (e: React.DragEvent<HTMLDivElement>) => void;
    isDragging?: boolean;
    children?: ReactNode;
}
export const DraggedCardWrapper:FC<DraggedCardWrapperProps> = ({
  isHovered,
  onDragOver,
  onDragEnter,
  onDrop,
  onDragStart,
  onDragEnd,
  isDragging,
  children,
}) => {
  const handleDragStart = (e: React.DragEvent<HTMLDivElement>): void => {
    if (!onDragStart || !isDragging) return;
    onDragStart(e);
  };

  const handleDragEnd = (e: React.DragEvent<HTMLDivElement>): void => {
    if (!onDragEnd || !isDragging) return;
    onDragEnd(e);
  };
  return (
    <DraggedCardContainer
      isHovered={isHovered || false}
      isDragging={isDragging || false}
      onDragOver={isDragging ? onDragOver : undefined}
      onDragEnter={isDragging ? onDragEnter : undefined}
      onDrop={isDragging ? onDrop : undefined}
    >
      {isDragging && (
        <MoveIcon>
          <Move size={18} strokeWidth={1.5} />
        </MoveIcon>
      )}
      <DragHandle
        draggable
        role="button"
        tabIndex={0}
        aria-label="Przeciągnij kartę aby zmienić kolejność"
        onDragStart={isDragging ? handleDragStart : undefined}
        onDragEnd={isDragging ? handleDragEnd : undefined}
        onMouseDown={(e: DragEvent<HTMLDivElement>) => {
          e.currentTarget.style.cursor = 'grabbing';
        }}
        onMouseUp={(e: DragEvent<HTMLDivElement>) => {
          e.currentTarget.style.cursor = 'grab';
        }}
        onMouseEnter={(e: DragEvent<HTMLDivElement>) => {
          e.currentTarget.style.backgroundColor = '#f5f5f5';
        }}
        onMouseLeave={(e: DragEvent<HTMLDivElement>) => {
          e.currentTarget.style.backgroundColor = 'transparent';
        }}
      >
        {children}
      </DragHandle>

    </DraggedCardContainer>
  );
};
